<template>
  <div class="image-panorama">
    <!-- <img class="" src="@/content/welcome-image-1.jpg" alt=""> -->
    <span class=""
      :style="{'background-image': 'url(' + require('@/content/welcome-image-1.jpg') + ')'}"
    >
    </span>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped >
</style>
